import {
    DOB_SET_VALUE,
    COVER_LIMIT_SET_VALUE,
    PROFESSION_SET_VALUE,
    SPOUSE_INCLUDED_SET_VALUE,
    SPOUSE_DOB_SET_VALUE,
    CHILDREN_INCLUDED_SET_VALUE,
    CHILDREN_DOBS_SET_VALUE,
    SET_INPATIENT_COVER_VALUE,
    SET_OUTPATIENT_COVER_VALUE,
    SET_OUTPATIENT_COVER_OPTION_VALUE,
    SET_PHONE_NO_VALUE,
    SET_FULL_NAME_VALUE,
    SET_EMAIL_VALUE,
    setDOBValid,
    setCoverLimitValid,
    setProfessionValid,
    setSpouseIncludedValid,
    setSpouseDobValid,
    setChildrenIncludedValid,
    setChildrenDobsValid,
    setInpatientCoverValid,
    setOutpatientCoverValid,
    setOutpatientCoverOptionValid,
    setPhoneNoValid,
    setEmailValid,
    setFullNameValid,
} from '../../../actions/afyaImara/quote';

import { getSelectedProductId } from '../../../selectors/afyaImara/quote';
import {
    validateDateOfBirth,
    validateSingleSelection,
    validateName,
    validateNumber,
    validateCellphoneNumber,
    validateEmail,
} from '@om/validation';

import { validationIsEqual } from '../status';
let prevValidationAction = null;

export const quoteFormValidation = (store, next, action) => {
    const productId = getSelectedProductId(store.getState());
    const validationAction = (() => {
        let error;

        switch (action.type) {
            case SET_PHONE_NO_VALUE:
                error = validateCellphoneNumber(action.value, {
                    required: true,
                    min: 1,
                    subject: 'Phone number',
                    countryCode: 'ke',
                });
                return setPhoneNoValid(error);
            case SET_FULL_NAME_VALUE:
                error = validateName(action.value, {
                    required: true,
                    min: 1,
                    subject: 'Full Name',
                });
                return setFullNameValid(error);
            case SET_EMAIL_VALUE:
                error = validateEmail(action.value, {
                    required: true,
                    min: 1,
                    subject: 'Email Address',
                });
                return setEmailValid(error);
            case DOB_SET_VALUE:
                error =
                    productId != 2
                        ? validateDateOfBirth(action.value, { min: 18, max: 65 })
                        : validateDateOfBirth(action.value, { min: 65, max: 85 });

                return setDOBValid(error);

            case COVER_LIMIT_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Cover Limit',
                });
                return setCoverLimitValid(error);

            case SPOUSE_INCLUDED_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Spouse Included',
                });
                return setSpouseIncludedValid(error);

            case SPOUSE_DOB_SET_VALUE:
                error = validateNumber(action.value, { min: 18, max: 65 });
                return setSpouseDobValid(error);

            case CHILDREN_INCLUDED_SET_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Children Included',
                });
                return setChildrenIncludedValid(error);

            case SET_INPATIENT_COVER_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Inpatient Cover',
                });
                return setInpatientCoverValid(error);

            case SET_OUTPATIENT_COVER_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Outpatient Cover',
                });
                return setOutpatientCoverValid(error);

            case SET_OUTPATIENT_COVER_OPTION_VALUE:
                error = validateSingleSelection(action.value, {
                    subject: 'Outpatient Cover Option',
                });
                return setOutpatientCoverOptionValid(error);

            case CHILDREN_DOBS_SET_VALUE:
                if (Array.isArray(action.value)) {
                    if (action.value.length > 0) {
                        for (const dob of action.value) {
                            const customError = validateNumber(dob, { min: 0, max: 18 });

                            if (customError !== null) {
                                error = 'Ensure that children are between the ages of 0 and 18 years';
                                break;
                            }
                        }
                    } else {
                        error = validateNumber(action.value[0], { min: 0, max: 65 });
                    }
                } else {
                    let customError = validateNumber(action.value.newValue, { min: 0, max: 18 });

                    if (customError !== null) {
                        error = 'Ensure that children are between the ages of 0 and 18 years';
                    }
                }

                return setChildrenDobsValid(error);

            /*
            console.log(action.value);

            const childrenDobs = action.value;
            error = null;

            if (childrenDobs.length > 0) {
                for (const dob of childrenDobs) {
                    const customError = validateDateOfBirth(dob);

                    if (customError !== null) {
                        error = 'Ensure that all dates of birth match the dd/mm/yyyy format';
                        break;
                    }
                }
            } else {
                error = 'Enter atleast one date of birth for child';
            }

            return setChildrenDobsValid(error);
            */

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
